<template>
    <b-overlay :show="!enableBtn">
        <div class="bulletin-card">
            <b-card :img-src="titlePi" img-alt="bulletin-image" img-left class="mb-4 bulletin-card" v-if="refreshDom" img-height="100%" img-width="100%">
                <div class="card-content">
                    <div>
                        <label class="card-content-title">{{ title ? title:'' }}</label>
                    </div>
                    <div>
                        <label class="card-content-time">{{ date ? date.substring(0, 10):'' }}</label>
                    </div>
                    <div v-html="content" class="card-content-content">
                    </div>
                    <div>
                        <b-button pill variant="warning" size="sm" class="card-content-btn" :disabled="!enableBtn" @click="$router.push('/news/newsDetail/' + id)">{{ $t('News.more') }}>></b-button>
                    </div>
                </div>
            </b-card>
        </div>
    </b-overlay>
</template>

<script>
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'

const BulletinCard = Vue.extend({
  name: 'BulletinCard',
  props: {
    id: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    titlePic: {
      type: String,
      default: require('../../assets/logo.png')
    }
  },
  data: function () {
    return {
      refreshDom: true,
      titlePi: require('../../assets/logo.png')
    }
  },
  computed: {
    ...mapState({
      file: state => state.resource.file,
      status: state => state.resource.status
    }),
    ...mapGetters({
      isFileChange: 'resource/size'
    }),
    enableBtn () {
      return this.id !== 0
    }
  },
  watch: {
    id () {
      if (this.id !== 0) {
        console.log(111111)
        this.getTitlePic()
      }
    },
    isFileChange () {
      this.refresh()
    },
    titlePic () {
      // console.log(111111)
      let img = document.getElementsByClassName('card-img-left')[0]
      console.log(img.naturalWidth)
    }
  },
  mounted () {
    if (this.id !== 0) {
      this.getTitlePic()
      this.titlePi = this.file['news' + this.id]
      this.refresh()
    }
    // console.log(this.titlePi)
    // let img = document.getElementsByClassName('card-img-left')[0]
    // console.log(img)
    // let ratio = img.naturalWidth / img.naturalHeight
    // console.log(ratio)
    // if (ratio > 16 / 15) {
    //   document.getElementsByClassName('card-img-left')[0].style.width = '320px'
    //   document.getElementsByClassName('card-img-left')[0].style.height = img.naturalHeight * (320 / img.naturalWidth) + 'px'
    //   console.log(img.style.width)
    //   console.log(img.style.height)
    // }
  },
  methods: {
    refresh () {
      this.refreshDom = false
      this.$nextTick(() => {
        this.refreshDom = true
      })
    },
    getTitlePic () {
      this.$store.dispatch('resource/getFilePublic',
        { 'file': { 'location': this.titlePic, 'resource_name': 'news' + this.id }, 'type': 'news' + this.id })
        .then(() => {
          this.titlePi = this.file['news' + this.id]
          this.refresh()
        })
    }
  }
})
export default BulletinCard
</script>

<style scoped>
.bulletin-card {
    height: 300px;
    margin: 20px auto;
    margin-bottom: 10px;
    box-shadow: 5px 5px 10px #CCCCCC;
}
.card-content {
    text-align: left;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-25%, -50%);
    width: 60%;
}
.card-content-title {
    color: #1D8D85;
    font-weight: bold;
    line-height: 35px;
}
.card-content-time {
    line-height: 35px;
}
.card-content-content {
    height: 90px;
    overflow: hidden;
}
.card-content-btn {
    color: #ffffff;
    width: 90px;
    margin-top: 5px;
}
.card-img-left {
    width: 320px;
    height: 300px;
    display: block;
    object-fit: cover;
}
.card-img-left {
  object-fit: fill;
  height: auto;
  /* width: auto; */
  margin: auto;
}
</style>
